var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _rect2, _g, _rect3, _g2, _rect4, _rect5, _rect6, _path21, _rect7, _polygon, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 158.81 130.19",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 83.01,
    y1: 54.9,
    x2: 42.02,
    y2: 60.46,
    gradientTransform: "matrix(1, 0, 0, -1, -18.57, 131.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -547.98,
    y1: 61.6,
    x2: -499.46,
    y2: 27.21,
    gradientTransform: "translate(-471.09 123.94) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 84.42,
    y1: 69.76,
    x2: 76.09,
    y2: 16.29,
    gradientTransform: "matrix(1, 0, 0, -1, -7.29, 140.53)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 90.92,
    y1: 61.65,
    x2: 82.6,
    y2: 8.18,
    gradientTransform: "matrix(1, 0, 0, -1, -7.29, 140.53)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 91.34,
    y1: 69.04,
    x2: 81.27,
    y2: 4.4,
    gradientTransform: "matrix(1, 0, 0, -1, -7.29, 140.53)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 147.04,
    y1: 88.11,
    x2: 105.55,
    y2: 13.31,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M37.39,133.54c13.07,6.39,30,3.93,43.88,2,11-1.57,18.9-4,30-2.73a97.49,97.49,0,0,0,35-2.38c4.79-1.21,9.59-2.86,13.45-5.94s6.67-7.84,6.33-12.77c-.47-6.71-6.21-11.61-10-17.13-11.23-16.19-6.16-38.61-13-57.07A46.18,46.18,0,0,0,79.45,12.11c-15,7.32-25.11,20.44-39.45,28.8C32.24,45.43,23.72,49,17.49,55.49,10.6,62.63,7.24,72.75,7.29,82.67S10.56,102.32,15.4,111s11.44,16.56,20,21.52C36.08,132.87,36.73,133.21,37.39,133.54Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.69,114.84c-2.39.34-5.54,2.1-4.44,4.26A3.89,3.89,0,0,0,32,120.71a130.3,130.3,0,0,0,17.2,3.12c10.5,1.19,21.1,1.11,31.66,1l30.71-.26c12-.1,24.17-.21,36.06-2.16-1-5-6.9-7.1-11.95-7.65-12.5-1.38-25.28,1.06-37.6-1.41-6.3-1.27-12.51-3.82-18.93-3.31-6.9.54-11.71,4.19-18.72,3.56C51.59,112.81,42.43,113.57,33.69,114.84Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.45,116.87a4.36,4.36,0,0,0,.35,1.83,3,3,0,0,0,1.33,1.24,5.24,5.24,0,0,0,3.9.39.74.74,0,0,0,.45-.28.56.56,0,0,0,.08-.38,2.93,2.93,0,0,0-1-1.84,6.13,6.13,0,0,1-1.4-1.61c-.6-1.21-.16-4.42-2.43-3.9C47.81,112.75,48.4,115.52,48.45,116.87Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#fbb8aa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.14,119s-.33.8.07,1.26,4.49,3,7.25,1S51.71,119,51.71,119Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3,117.19a.59.59,0,0,1,.73.19,2.41,2.41,0,0,0,2.19.79c.9-.22,1.26-1.25,1.7-1.25s2.82,2,3,2.89-1.08,1.5-2.42,1.59-4.39-.85-5-1.55A2.9,2.9,0,0,1,48.3,117.19Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.65,118.1a4.56,4.56,0,0,0,.34,1.84,3.09,3.09,0,0,0,1.34,1.24,5.28,5.28,0,0,0,3.9.38.73.73,0,0,0,.45-.27.66.66,0,0,0,.08-.39,2.9,2.9,0,0,0-1-1.83,6.9,6.9,0,0,1-1.41-1.6c-.59-1.21-.15-4.42-2.42-3.91C40,114,40.6,116.77,40.65,118.1Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#fbb8aa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.34,120.29s-.32.79.07,1.26,4.48,3,7.24,1-3.74-2.31-3.74-2.31Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,118.44a.57.57,0,0,1,.73.19,2.38,2.38,0,0,0,2.19.78c.89-.21,1.26-1.24,1.69-1.25s2.83,2,3,2.89-1.08,1.51-2.42,1.59-4.39-.84-5-1.55A2.87,2.87,0,0,1,40.5,118.44Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39,84.53s-.42,23.37,1.31,31.16l4.4.54,3-32Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#473f47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6,82s2.06,12.6-.44,32.84l-4.4.55-3-32Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#473f47"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.74,71.94c-.05.84-.32,1.58-1.06,1.82l-.19,0c-1.35.27-3.12-.75-4.35-1.65A16.87,16.87,0,0,1,50.66,71v-9l6.56,6.72A10.43,10.43,0,0,1,57.74,71.94Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.19,72.12c0,.42.06.85.06,1.27,0,2.33-.54,4.74.15,7A2.52,2.52,0,0,1,52.6,82a2,2,0,0,1-1,.94,19.46,19.46,0,0,1-6.75,1.8c-1.74.24-4.22.76-5.83-.18a2.89,2.89,0,0,1-1.14-1.89,35.75,35.75,0,0,1-1.09-7.35c0-.33-.05-.65-.06-1-.14-2.24-.18-4.47-.14-6.71,0-1.62.16-3.37,1.22-4.59A11.58,11.58,0,0,1,44,59.93a6.64,6.64,0,0,1,2-.11,8.44,8.44,0,0,1,2.75.93,4.68,4.68,0,0,1,2.44,2,13.82,13.82,0,0,1,1.15,3.7A13.37,13.37,0,0,1,52.49,70c-.06.59-.21,1.18-.27,1.77A1.73,1.73,0,0,0,52.19,72.12Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.68,85.32c-.68.2-2.24-.42-2.76-.51-.31,0-.59-.21-.9-.28-1.54-.39-1.72-4.73-1.87-5.89a82.84,82.84,0,0,1-1.06-9.38,10,10,0,0,1,.41-3.53,4.09,4.09,0,0,1,2.31-2.58c2-.71,2.56,5.53,2.83,6.82.34,1.62.69,3.24,1,4.85.24,1.19.11,2.13,1,3a.49.49,0,0,0,.24.14.48.48,0,0,0,.24-.06,3.51,3.51,0,0,1,1.24-.29.78.78,0,0,1,.94.7,2.78,2.78,0,0,1-1.19,2.93c-.42.27-.9.41-1.33.67-1.59,1-.26,2-.89,3.2A.42.42,0,0,1,42.68,85.32Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#020202",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.43,58a1.47,1.47,0,0,1-1,.47,4.62,4.62,0,0,1-.91,0h-.17a.2.2,0,0,0-.13,0,.24.24,0,0,0,0,.14,10.18,10.18,0,0,0,0,1.83h0c0,.11,0,.22,0,.33a.6.6,0,0,1,0,.35.55.55,0,0,1-.37.24,2.9,2.9,0,0,1-.83.15,3.67,3.67,0,0,1-1.69-.6,17.25,17.25,0,0,0-.17-3.13,16.63,16.63,0,0,1-.4-4,2.2,2.2,0,0,1,2.55-2.18,5,5,0,0,1,2.73.75,1.09,1.09,0,0,1,.41.81c.1.53.19,1.06.24,1.6s.11,1.22.12,1.83A2.08,2.08,0,0,1,47.43,58Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#fbb8aa"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.34,65.17c.06-.09.18-.19.27-.13a.26.26,0,0,1,.08.13.59.59,0,0,0,.54.31c.21,0,.43,0,.65,0a1.83,1.83,0,0,1,1.44.78,2.85,2.85,0,0,1,.52,1.59,2,2,0,0,1-.39,1.44,2.68,2.68,0,0,1-2.15.57l-.7,0a.66.66,0,0,1-.73-.53c-.29-.69-.81-1.39-.45-2.09A12.24,12.24,0,0,1,63.34,65.17Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#fbb8aa"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.56,52.88a1.25,1.25,0,0,1-.91.29c-.9-.06-1.29-.62-2,.25a2,2,0,0,0-.42,1c0,.08,0,1,.08,1-.26.09-.31-.38-.51-.57s-.66.07-.69.39a1.85,1.85,0,0,0,.29.93A2.87,2.87,0,0,1,42.52,58c0,.15-.15.32-.29.28S42,58,41.9,57.88a5,5,0,0,0-.46-.46c-.5-.44-1.35-.78-1.72-1.3a1.4,1.4,0,0,1-.23-.95c0-.08.26-.89.39-.81a1.17,1.17,0,0,1,.14-2,2.35,2.35,0,0,1,1.19-2.67,4.84,4.84,0,0,1,3.08-.38,7.79,7.79,0,0,1,3.26,1.16,2.56,2.56,0,0,1,.84.83,1.26,1.26,0,0,1,.1,1.15.38.38,0,0,1-.36-.18.72.72,0,0,1-.65.77.68.68,0,0,1-.7-.4A.89.89,0,0,1,46.56,52.88Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#473f47"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.56,58.49h-.17a.2.2,0,0,0-.13,0,.24.24,0,0,0,0,.14,10.18,10.18,0,0,0,0,1.83h0a2.45,2.45,0,0,1-1.69-2.6,10,10,0,0,0,2.07.61Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#dc9e93"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.21,69.59a12.87,12.87,0,0,1-3.15,3.14,6.3,6.3,0,0,1-3,1.06,1,1,0,0,1-.42-.05,1,1,0,0,1-.57-.39,3.3,3.3,0,0,1-.76-1.87c-.07-1.8,1.88-2.85,1.88-2.85s4.44-1.41,5-1.18c.29.12.57.75.76,1.29S63.21,69.59,63.21,69.59Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.21,69.59a12.87,12.87,0,0,1-3.15,3.14,6.3,6.3,0,0,1-3,1.06,1,1,0,0,1-.42-.05,1.06,1.06,0,0,1-.19.06c-1.35.27-3.11-.76-4.35-1.66l-1.48-.53-.42-4.19s3.56,3.32,5.11,4.06a4,4,0,0,0,2.38.44,2.7,2.7,0,0,0,.63-.19,20.71,20.71,0,0,0,4.57-3A7.12,7.12,0,0,1,63.21,69.59Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#020202",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.62,73.9,49,70.11a.62.62,0,0,1,.59-.57l5-.25a.64.64,0,0,1,.66.61.48.48,0,0,1,0,.12l-1.31,8.63a.62.62,0,0,1-.54.53l-4.61.64a.64.64,0,0,1-.71-.55.57.57,0,0,1,0-.13Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.24,70l-1.3,8.63a.64.64,0,0,1-.54.53l-4.58.64h0a.63.63,0,0,1-.72-.54.76.76,0,0,1,0-.15l.56-5.24L49,70.11a.63.63,0,0,1,.6-.56l5-.25a.63.63,0,0,1,.65.55A.37.37,0,0,1,55.24,70Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.24,70l-1.3,8.63a.64.64,0,0,1-.54.53l-4.58.64a.38.38,0,0,1,0-.15l.55-5.23.37-3.8a.63.63,0,0,1,.59-.57l4.89-.24A.31.31,0,0,1,55.24,70Z",
    transform: "translate(-7.29 -7.47)",
    fill: "url(#linear-gradient)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.09,73.84a.81.81,0,0,1,.7-.29,2.26,2.26,0,0,1,.42.26.93.93,0,0,0,.4.09,4,4,0,0,0,1.64-.23,2.13,2.13,0,0,1,.85-.21,1.26,1.26,0,0,1,.85.6A2.4,2.4,0,0,1,52,76.65a2.51,2.51,0,0,1-.85.77,5.29,5.29,0,0,1-2.42.61c-.85,0-1.7,0-2.53,0a1,1,0,0,1-.58-.07.9.9,0,0,1-.28-.74,2.5,2.5,0,0,1,.23-1.71C46.06,74.9,46.6,74.42,47.09,73.84Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#fbb8aa"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.83,63s-9.27,12.12-6.34,16.4,15.28-.71,15.28-.71l-1.2-3.54s-8.68,1.1-8.75.13,5.51-6.54,5.51-6.54S43.33,60.61,37.83,63Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.49,
    y: 55.48,
    width: 63.41,
    height: 46.12,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.05,
    y: 94,
    width: 55.66,
    height: 2.19,
    fill: "#2d3a46"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.06,
    y: 77.13,
    width: 5.4,
    height: 4.71,
    fill: "#2d3a46"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.7,
    y: 73.47,
    width: 5.4,
    height: 8.36,
    fill: "#2d3a46"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.35,
    y: 69.61,
    width: 5.4,
    height: 12.23,
    fill: "#2d3a46"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.99,
    y: 65.85,
    width: 5.4,
    height: 15.99,
    fill: "#2d3a46"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.63,
    y: 62.06,
    width: 5.4,
    height: 19.78,
    fill: "#2d3a46"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60.63,
    y: 62.06,
    width: 5.4,
    height: 19.78,
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.56,30.71a7.1,7.1,0,0,1-7.09,7.1H89.26a7.1,7.1,0,1,1,0-14.19h2.62a5.63,5.63,0,0,1,0-.58,6.52,6.52,0,0,1,13-.23V23a5.63,5.63,0,0,1,0,.58h2.61a7.08,7.08,0,0,1,7.09,7.09Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46",
    opacity: 0.31,
    style: {
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.36,30a7.1,7.1,0,0,1-7.09,7.1H87.05a7.1,7.1,0,0,1,0-14.19h2.62a5.63,5.63,0,0,1,0-.58,6.52,6.52,0,0,1,13,0h0a5.63,5.63,0,0,1,0,.58h2.62A7.1,7.1,0,0,1,112.36,30Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 88.19,
    y: 29.66,
    width: 1.36,
    height: 6.01,
    fill: "#2d3a46"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "105.75 44.61 104.39 44.61 104.39 36.35 72.83 36.35 72.83 44.61 71.47 44.61 71.47 34.99 105.75 34.99 105.75 44.61",
    fill: "#2d3a46"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 88.19,
    y: 35.67,
    width: 1.36,
    height: 8.95,
    fill: "#2d3a46"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 102.31,
    y: 44.61,
    width: 5.24,
    height: 5.24,
    fill: "#2d3a46"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 86.25,
    y: 44.61,
    width: 5.24,
    height: 5.24,
    fill: "#2d3a46"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 69.64,
    y: 44.61,
    width: 5.24,
    height: 5.24,
    fill: "#2d3a46"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 61.05,
    y: 85.82,
    width: 55.66,
    height: 2.19,
    fill: "#2d3a46"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 61.05,
    y: 85.82,
    width: 27.14,
    height: 2.19,
    fill: "url(#linear-gradient-3)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 67.55,
    y: 93.92,
    width: 27.14,
    height: 2.19,
    fill: "url(#linear-gradient-4)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 61.05,
    y: 89.91,
    width: 55.66,
    height: 2.19,
    fill: "#2d3a46"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 63.13,
    y: 89.91,
    width: 35.75,
    height: 2.19,
    fill: "url(#linear-gradient-5)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103.14,77.35a6.61,6.61,0,0,1,.58-2.69l-4-2.18a11,11,0,0,0,5,14.75,11.49,11.49,0,0,0,2.19.8l.81-4.51A6.45,6.45,0,0,1,103.14,77.35Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.06,83a11,11,0,0,1-12.17,5l.81-4.51A6.44,6.44,0,0,0,115,80.83Z",
    transform: "translate(-7.29 -7.47)",
    fill: "#2d3a46",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.62,77.35A11,11,0,0,1,119.06,83l-4-2.19a6.46,6.46,0,0,0-10.87-7,5.31,5.31,0,0,0-.44.81l-4-2.18a11,11,0,0,1,20.92,4.87Z",
    transform: "translate(-7.29 -7.47)",
    fill: "url(#linear-gradient-6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataStorage);
export default __webpack_public_path__ + "static/media/dataStorage.975fe7fcc94dfa3cd428f34389b18dbc.svg";
export { ForwardRef as ReactComponent };